@if (user(); as user) {
  <div class="person">
    <procure-avatar
      class="avatar"
      [name]="user.name"
      [avatar]="user.avatarUrl"
    />
    <span
      [attr.data-testid]="TestIds.Name"
      [class.current]="user?.isCurrentUser"
    >
      {{ user.name }}
    </span>
  </div>
}
